import React, { forwardRef } from 'react'
import cx from 'classnames'

const Box = forwardRef(({
  className,
  ...props
}, ref) => {
  const classes = cx(className, 'm-box')

  return (
    <div
      className={classes}
      ref={ref}
      {...props}
    />
  )
})

export default Box
